/**
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.dev/license
 */
// THIS CODE IS GENERATED - DO NOT MODIFY.
const u = undefined;
export default [[["mn", "o", "m", "a", "n"], ["middernag", "die oggend", "die middag", "die aand", "die nag"], u], [["mn", "o", "m", "a", "n"], ["middernag", "oggend", "middag", "aand", "nag"], u], ["00:00", ["05:00", "12:00"], ["12:00", "18:00"], ["18:00", "24:00"], ["00:00", "05:00"]]];
